const successCache = new Set();
const failedCache = new Set();
const pendingMap = new Map();

export const bulletinLogoManager = (src, signal) => {
  if (!src) return Promise.reject();

  // ✅ Success cache
  if (successCache.has(src)) {
    return Promise.resolve(src);
  }

  // ✅ Failed cache
  if (failedCache.has(src)) {
    return Promise.reject(new Error('404'));
  }

  // ✅ Duplicate request önleme
  if (pendingMap.has(src)) {
    return pendingMap.get(src);
  }

  const promise = fetch(src, {
    method: 'HEAD',
    signal,
  })
    .then(res => {
      if (res.status === 404) {
        failedCache.add(src);
        throw new Error('404');
      }

      if (!res.ok) {
        throw new Error('Temporary error');
      }

      successCache.add(src);
      return src;
    })
    .finally(() => {
      pendingMap.delete(src);
    });

  pendingMap.set(src, promise);
  return promise;
};
